<h1 mat-dialog-title>Changer la photo de profil</h1>
<div mat-dialog-content>
  <input type="file" (change)="onFileSelected($event)" accept="image/*">
  <div *ngIf="selectedImage">
    <img [src]="selectedImage" alt="Selected Image" class="selected-image-preview">
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">Annuler</button>
  <button mat-button color="primary" (click)="onConfirm()">Valider</button>
</div>
